<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="拍品名称">{{info.name}}</a-form-item>
      <a-form-item label="拍品图片">
        <img style="height: 40px" :src="info.thumb" alt="">
      </a-form-item>
      <a-form-item label="拍品编号">{{info.sn}}</a-form-item>
      <a-form-item label="起拍价">{{info.price}} 元</a-form-item>
      <a-form-item label="说明信息">{{info.desc}}</a-form-item>
      <a-form-item label="添加时间">{{info.created_at}}</a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="update">编辑</a-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.form {
  padding: 40px;
}
.sec {
  margin: 15px;
}
img {
  max-width: 100%;
}
</style>

<script>
export default {
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      cateList: [],
      info: {},
    };
  },
  async created() {
    const id = this.$route.query.id;
    const r = await this.$axios.get("/auction/goods/getInfo?id=" + id);
    if (r.status == 1) {
      this.info = r.info;
    }
  },
  methods: {
    update() {
      this.$router.push(`/auction/goods/update?id=${this.info.id}`);
    },
  },
};
</script>